import DownloadOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import Header from "../../components/Header";

const Dashboard = () => {
  return (
    <Box m="20px" height="80vh" overflow="auto" paddingRight="20px">
      <Box>
        <Header title="DASHBOARD" subtitle="Welcome to your dashboard" sx={{
    color: "#6e0506 ", // Red color for the title and subtitle
  }}  />

        {/* Buttons container */}
        <Box display="flex" gap="18px" mt="20px">
          <Link to="/changeContent">
            <Button
             sx={{
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              borderRadius: "10px",
              border: "3px solid #6e0506",
              backgroundColor: "#ffffff",
              color: "#6e0506",
              "&:hover": {
                backgroundColor: "#6e0506",
                color: "#fff",
              },
            }}
            >
              <DownloadOutlinedIcon sx={{ mr: "10px" }} />
              Change Content
            </Button>
          </Link>

          <Link to="/changeBanner">
            <Button
              Button
              sx={{
               backgroundColor: "#ffffff",
               color: "#6e0506",
               fontSize: "14px",
               fontWeight: "bold",
               padding: "10px 20px",
               border: "3px solid #6e0506",
               borderRadius: "10px",
               "&:hover": {
                 backgroundColor: "#6e0506",
                 color: "#fff",
               },
             }}
            >
              <DownloadOutlinedIcon sx={{ mr: "10px" }} />
              Change Banner
            </Button>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
